import { render, staticRenderFns } from "./TeachResources.vue?vue&type=template&id=414d7404&scoped=true"
import script from "./TeachResources.vue?vue&type=script&lang=js"
export * from "./TeachResources.vue?vue&type=script&lang=js"
import style0 from "./TeachResources.vue?vue&type=style&index=0&id=414d7404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d7404",
  null
  
)

export default component.exports